"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

// iOS zooms in when focusing an input under 16px (ours are ~14px on phones).
// maximum-scale=1 stops that zoom, and iOS still allows pinch-zoom with it.
// Android would lose pinch-zoom, so only apply it on iOS.
export default function IOSInputZoomFix() {
  const pathname = usePathname();

  useEffect(() => {
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    if (!isIOS) return;

    const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
    if (!meta || meta.content.includes("maximum-scale")) return;
    meta.content += ", maximum-scale=1";
  }, [pathname]);

  return null;
}
